import {RestClient} from '../rest-client';
import {MBIDAuthService} from './MBIDAuthService/MBIDAuthService';
import {OAuth2Service} from './OAuth2Service/OAuth2Service';

export class RestAPI {
  constructor(client: RestClient) {
    this.client = client;
    this.mbidAuth = new MBIDAuthService(client);
    this.oauth2 = new OAuth2Service(client);
  }

  client: RestClient;
  mbidAuth: MBIDAuthService;
  oauth2: OAuth2Service;
}
export default RestAPI;
